import {computed} from "vue";
import { useGlobalState } from "@/composables/useAsideMenuGlobalState";
import { menuItems } from "@/router/menuItemsAside";
//import store from "@/store";
import { useStore } from "vuex";

export function useAsideFunctions() {
   const store = useStore(); 
  const { isMenuCollapsed, toggleMenu } = useGlobalState();

  function itemHasRole(item) {
    const userRole = store.getters["auth/userRole"];
    if (!item.meta?.roles) return true;
    return Array.isArray(item.meta.roles) && item.meta.roles.includes(userRole);
  }

  const filterMenuItems = (items) => {
    return items
        .map(item => {
          const hasPermission = itemHasRole(item);

          if (item.submenu?.length > 0) {
            const filteredSubmenu = filterMenuItems(item.submenu);

            if (hasPermission && filteredSubmenu.length > 0) {
              return {
                ...item,
                submenu: filteredSubmenu,
              };
            }

            return null;
          }

          return hasPermission ? { ...item } : null;
        })
        .filter(Boolean);
  };

  // Aplicando o filtro aos itens do menu
  const navMenuItems = computed(() => {
    return filterMenuItems(menuItems.value);
  });


  function selectMenuItem(item) {
    navMenuItems.value.forEach((menuItem) => {
      menuItem.active = menuItem === item;
      menuItem.submenu?.forEach((subItem) => {
        subItem.active = subItem === item;
      });
    });
  }

  function selectMenuItemDesktop(item) {
    selectMenuItem(item);
  }

  function selectMenuItemMobile(item) {
    selectMenuItem(item);
    toggleMenu();
  }

  return {
    navMenuItems,
    isMenuCollapsed,
    toggleMenu,
    selectMenuItemDesktop,
    selectMenuItemMobile,
    itemHasRole,
  };
}
